import React, { useState, useContext } from 'react';
import AppBar from './components/AppBar';
import { Button, Text, TextArea, Spinner, FormControl } from 'native-base';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { VStack } from 'native-base';
import { postContactError } from "./services/picnicapi"
import AlertBox from "./components/AlertBox"
import { LanguageContext } from './context/LanguageProvider';
import { Formik } from 'formik';

export default function NewAreaPage() {
    let { state } = useLocation();
    const { i18n } = useContext(LanguageContext)
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSucces] = useState(false);
    const navigate = useNavigate();

    const validate = (values) => {
        const errors = {};
        if (!values.texto.length > 0) {
            errors.errorText = i18n.t("info_zona_error_error")
        }
        return errors;
    }

    const onSubmit = async (values) => {
        setLoading(true);
        postContactError(values)
            .then((response) => {
                if (response) { //si es true
                    setLoading(false);
                    setShowSucces(true);
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    }

    const onCloseSucces = () => {
        navigate(-1);
    }

    return (<>
        <AppBar title={i18n.t("info_zona_error_titulo")} backButton={true} />
        <Formik initialValues={{
            texto: '',
            zonaId: state.id
        }} onSubmit={onSubmit} validate={validate}>
            {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                errors
            }) => (
                showSuccess ? (<AlertBox
                    header={i18n.t("info_zona_error_titulo")}
                    body={i18n.t("info_zona_error_enviado")}
                    isOpen={showSuccess}
                    textButton1={i18n.t("btn_ok")}
                    onPressButton1={() => onCloseSucces()} />) : (
                    <><VStack alignItems="left" space="5" mb="2rem" padding="30px">
                        <div style={{ marginTop: "70px" }} />
                        <Text>{i18n.t("info_zona_error_descripcion")}</Text>
                        <FormControl isRequired mt isInvalid={'errorText' in errors}>
                            <TextArea h={40} onBlur={handleBlur('texto')} onChangeText={handleChange('texto')} value={values.texto} />
                            <FormControl.ErrorMessage _text={{
                                fontSize: 'xs'
                            }}>
                                {errors.errorText}
                            </FormControl.ErrorMessage>
                        </FormControl>
                    </VStack>
                        <VStack alignItems="center">
                            {loading ? (
                                <Spinner size="lg" color='darkolivegreen' />) :
                                (<Button block style={{ backgroundColor: 'darkolivegreen' }} onPress={handleSubmit}>
                                    <Text style={{ color: 'white' }}>{i18n.t("info_zona_error_boton")}</Text>
                                </Button>)}
                        </VStack></>)
            )}
        </Formik>
    </>
    );
}